import { Box, Skeleton, Stack } from '@mui/material';
import React, { PropsWithChildren } from 'react';

const DEFAULT_SKELETON_COUNT = 5;
const DEFAULT_SKELETON_HEIGHT = 100;

interface CardsProps {
  loading?: boolean;
  skeletonCount?: number;
  skeletonHeight?: number;
}

export const DataGridCards: React.FC<PropsWithChildren<CardsProps>> = ({
  children,
  loading,
  skeletonCount = DEFAULT_SKELETON_COUNT,
  skeletonHeight = DEFAULT_SKELETON_HEIGHT
}) => {
  if (loading) {
    return (
      <Stack spacing={0.5}>
        {Array.from({ length: skeletonCount }, (_, index) => (
          <Skeleton key={index} height={skeletonHeight} variant="rectangular" sx={{ borderRadius: 1 }} />
        ))}
      </Stack>
    );
  }

  return <Stack spacing={0.5}>{children}</Stack>;
};

interface CardProps {
  id?: string;
}

export const DataGridCard: React.FC<PropsWithChildren<CardProps>> = ({ children, id }) => (
  <Box
    id={id}
    p={2}
    sx={(theme) => ({
      backgroundColor: theme.custom.background.level3,
      borderRadius: 1
    })}
  >
    {children}
  </Box>
);

export default DataGridCards;
